import '../../style/';
import './index.less';



// WEBPACK FOOTER //
// ./components/card/style/index.tsx